import SparkleIcon from '@mui/icons-material/AutoAwesome';
import { Button } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/system';

const GradientButton = styled(Button)({
  cursor: 'pointer',
  display: 'inline-block',
  padding: '1px',
  borderRadius: '8px',
  background: 'linear-gradient(120deg, #4285F4, #34A853, #FBBC04, #EA4335)',
  transition: 'background 0.3s ease',
  '& .button-bg': {
    background: 'linear-gradient(120deg, #BFDED7, #CDE3C1, #FAE5B1, #F8D9B6, #F7CCBB)',
    borderRadius: '7px',
    padding: '5px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 'bold',
    fontSize: '16px',
    textTransform: 'none',
    transition: 'background 0.3s ease, color 0.3s ease',
  },
  '&:hover': {
    background: 'linear-gradient(120deg, #BFDED7, #CDE3C1, #FAE5B1, #F8D9B6, #F7CCBB)',
  },
  '&:hover .button-bg': {
    background: '#fff',
  },
});

const AIButton = ({ children = 'Ask ForecasterAI', ...props }: ButtonProps) => {
  return (
    <GradientButton {...props}>
      <div className='button-bg'>
        <SparkleIcon sx={{ fontSize: '16px' }} />
        {children}
      </div>
    </GradientButton>
  );
};

export default AIButton;
